import { useEffect, useState } from "react";
import { COUNTDOWN_SECONDS } from "../data/offer";

// Shared start time keeps every timer on the page in sync.
const START = Date.now();

export function useCountdown() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const elapsed = Math.floor((now - START) / 1000);
  const remaining = COUNTDOWN_SECONDS - (elapsed % COUNTDOWN_SECONDS);

  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  };
}

function pad(n: number) {
  return n.toString().padStart(2, "0");
}
